'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var signup = require('../adapter/users/signup.js');
require('../util/interfaces.js');
require('../util/user.constants.js');
require('../util/normalize.js');
var date = require('../util/date.js');
require('../util/static-content.js');
var index = require('../adapter/index.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Wallet {
  getGamingAccounts() {
    return index.adapter.wallet.getGamingAccounts();
  }
  getApplicableBonuses() {
    return __async(this, null, function* () {
      const result = yield index.adapter.wallet.getApplicableBonuses();
      return result ? result : [];
    });
  }
  getDepositRemainingLimits() {
    return __async(this, null, function* () {
      return yield index.adapter.wallet.getDepositRemainingLimits();
    });
  }
  forfeitBonus(bonusId) {
    const params = { userBonusId: bonusId };
    return index.adapter.wallet.forfeitBonus(params);
  }
  getGrantedBonuses() {
    return index.adapter.wallet.getGrantedBonuses();
  }
  getTransactionHistory(from, to) {
    return this.splitDatedRequest(from, to, (newFrom, newTo) => {
      const params = { from: newFrom, to: newTo };
      return index.adapter.wallet.getTransactionHistory(params);
    });
  }
  getGamesTransactions(from, to) {
    return this.splitDatedRequest(from, to, (newFrom, newTo) => {
      const params = { from: newFrom, to: newTo };
      return index.adapter.wallet.getGamesTransactions(params);
    });
  }
  getBettingHistoryTotalNetWins(from, to) {
    return __async(this, null, function* () {
      const params = {
        settledFrom: date.formatDate(from),
        settledTo: date.formatDate(to)
      };
      return index.adapter.wallet.getBettingHistoryTotalNetWins(params);
    });
  }
  getBettingHistory(params) {
    const normalized = __spreadProps(__spreadValues({}, params), {
      settledDateFrom: date.formatDate(params.settledDateFrom),
      settledDateTo: date.formatDate(params.settledDateTo)
    });
    if (params.placedDateFrom) {
      normalized.placedDateFrom = date.formatDate(params.placedDateFrom);
    }
    if (params.placedDateTo) {
      normalized.placedDateTo = date.formatDate(params.placedDateTo);
    }
    return index.adapter.wallet.getBettingHistory(normalized);
  }
  getBonusesHistory(from, to) {
    return this.splitDatedRequest(from, to, (newFrom, newTo) => {
      const params = { from: newFrom, to: newTo };
      return index.adapter.wallet.getBonusesHistory(params);
    });
  }
  getLifetimeDeposits() {
    return index.adapter.wallet.getLifetimeDeposits();
  }
  getComputedBalance() {
    return __async(this, arguments, function* (currency = signup.Currency.EUR) {
      const { accounts } = yield this.getGamingAccounts();
      const initialBalance = {
        balance: 0,
        realBalance: 0,
        bonusBalance: 0,
        bonusRealMoneyBalance: 0,
        bonusBonusMoneyBalance: 0
      };
      return accounts.filter((account) => account.currency === currency).reduce((prev, account) => {
        const { amount, bonusMoney, realBonusMoney, isBonusAccount } = account;
        return Object.assign(prev, {
          balance: prev.balance + amount,
          realBalance: isBonusAccount ? prev.realBalance : prev.realBalance + amount,
          bonusBalance: isBonusAccount ? prev.bonusBalance + amount : prev.bonusBalance,
          bonusRealMoneyBalance: prev.bonusRealMoneyBalance + (isBonusAccount && realBonusMoney || 0),
          bonusBonusMoneyBalance: prev.bonusBonusMoneyBalance + (isBonusAccount && bonusMoney || 0)
        });
      }, initialBalance);
    });
  }
  splitDatedRequest(from, to, handler, maxDays = 60) {
    return __async(this, null, function* () {
      const requests = date.chunkDateRange(from, to, maxDays).map(([chunkedFrom, chunkedTo]) => () => handler(new Date(chunkedFrom), new Date(chunkedTo)));
      let res = [];
      for (const request of requests) {
        const currentResponse = yield request();
        res = currentResponse.concat(res);
      }
      return res;
    });
  }
}
const wallet = new Wallet();

exports.wallet = wallet;
